const resources = {
    seeDetails: 'Voir les détails'
};

export default function getResource(label) {
    return resources[label];
}
